<template>
<div class="organization-update update-form">
  <form class="email-template-update--form" @submit.prevent="update">
    <field :errors="errors" :required="true" model="email_template" name="name" v-model="item.name"></field>
    <field :errors="errors" model="email_template" name="language" :required="true" v-model="item.language" placeholder="en"></field>

    <br>
    <field :errors="errors" model="email_template" name="from" v-model="item.from" placeholder="John Smith"></field>
    <field :errors="errors" model="email_template" name="reply_to" v-model="item.reply_to" placeholder="noreply@example.com"></field>
    <br>
    <field :errors="errors" model="email_template" name="salutation" ref="salutation" v-model="item.salutation" placeholder="Hi [[firstname]]"></field>
    <field-filler :elements="$refs" v-model="item.salutation" element-name="salutation" :values="placeholderSalutationCollection"/>
    <field :errors="errors" model="email_template" name="salutation_fallback" v-model="item.salutation_fallback" placeholder="Hi dear"></field>

    <field :errors="errors" ref="body" model="email_template" name="body" type="textarea" :required="true" v-model="item.body"></field>
    <field-filler :elements="$refs" v-model="item.body" element-name="body" :values="placeholderBodyCollection"/>

    <br>
    <field :errors="errors" model="email_template" name="imprint_url" v-model="item.imprint_url"></field>
    <field :errors="errors" model="email_template" name="privacy_url" v-model="item.privacy_url"></field>
    <br>

    <div class="update-form--actions">
      <button class="btn btn-tertiary" @click.prevent="cancel" data-action="email-templates.cancel">{{ $t('ui.global.cancel') }}</button>
        <button class="btn btn-primary btn-save" type="submit" data-action="email-templates.update">{{ $t('ui.global.save') }}</button>
    </div>
  </form>
</div>
</template>
<script>
import Api from '@/api/EmailTemplate.js'
import {updateMixin} from '@/components/mixins/Update'
import ProjectApi from '@/api/Project.js'
import FieldFiller from '@/components/helpers/DataInput/FieldFiller'
let default_color = '#000000'

let placeholderSalutationCollection = [
  { name: 'formal', code: 'ui.email_template.placeholders.formal', content: '[[formal]]' },
  { name: 'informal', code: 'ui.email_template.placeholders.informal', content: '[[informal]]' },
  { name: 'gender', code: 'ui.email_template.placeholders.gender', content: '[[gender]]' }
]

let placeholderBodyCollection = [
  { name: 'form_title', code: 'ui.email_template.placeholders.form_title', content: '[[form_title]]' }
]

export default {
  mixins: [updateMixin],
  components: { FieldFiller},
  data(){
    return {
      model: "email_templates",
      api: new Api(),
      projects: [],
      primary_color: null,
      placeholderBodyCollection,
      placeholderSalutationCollection
    }
  },
  mounted(){
    this.colorInit()
  },
  methods: {
    afterRetrieve(){
      this.colorInit()
    },
    colorInit(){
      if(!this.item.primary_color){
        this.item.primary_color = default_color
      }
      this.primary_color = this.item.primary_color
    }
  },
  watch: {
    primary_color:{
      deep: true,
      handler(val){
        this.item.primary_color = val.hex
      }
    }
  }
}

</script>
<style lang="scss">
.email-template-update--form{
  label .optional{
    display: none;
  }
.vc-chrome {
  margin-top: 2em;
  box-shadow: 0 0 9px 0 rgba(189, 189, 189, 0.5);
}
.update-form--actions {
  text-align: right;
}
}
</style>



// WEBPACK FOOTER //
// EmailTemplateUpdate.vue?96462c8e